(function ($) {
    $.fn.floating = function () {
        var prop = $(this).css('float');

        return prop === 'left' || prop === 'right';
    };
})(jQuery);